class BulkUploadController {
  /* @ngInject */
  constructor($http, $state, $timeout, Session) {
    this.$http = $http;
    this.$state = $state;
    this.$timeout = $timeout;
    this.Session = Session;
  }

  $onInit() {
    this.data = {};

    this.uploading = false;
  }

  upload() {
    if (this.uploading) return null;
    this.uploading = true;

    return this.$http
      .post('/case/bulkUpload', this.data)
      .then(({ data }) => {
        this.uploading = false;

        if (data.errorMsg) {
          this.error = data.errorMsg;

          this.$timeout(() => {
            this.error = '';
          }, 15000);
        } else {
          this.$state.go('main.cases.list');
        }
      })
      .catch(() => {
        this.uploading = false;
        this.error = 'Something went wrong, please contact employeebgc.com';
      });
  }
}

export default BulkUploadController;



// WEBPACK FOOTER //
// ./client/app/cases/bulkUpload/bulkUpload.controller.js